import Cookies from 'js-cookie';
import { CookieData, sessionStoregeItemAndCookieName, onCancelClick, onPaymentCompletedHandler, onPaymentAttemptStarted } from './SwedbankPay';

function disableElements(elems: Element[]) {
    elems?.forEach((el) => disableElement(el));
}
function disableElement(el: Element) {
    el?.setAttribute('disabled', '');
}

document.addEventListener('DOMContentLoaded', function (event) {
    const registrationMarker = document.getElementById('supportregistrationpage');
    if (!registrationMarker) return;

    document.querySelector('#social-security-num-sup')?.addEventListener('change', onPersonalNumberChange, null);
    const cancelButton = document.querySelector('#btn-cancel-payment');

    var activeFormData = sessionStorage.getItem(sessionStoregeItemAndCookieName);
    if (activeFormData != null) {
        // @ts-ignore
        $('#registerSupportMember').find('.row').addClass('hidden');
        // @ts-ignore
        $('#registerSupportMember').find('.form-box__highlight').addClass('hidden');
        // @ts-ignore
        $('#registerSupportMember').find('input[type="submit"]').addClass('hidden');
    }

    const radioButtons = document.querySelectorAll('input[name="paymentMethod"]');
    if (radioButtons.length > 0) {
        radioButtons.forEach(function (radioButton, i) {
            radioButton.addEventListener('change', function () {
                const payButton = document.getElementById('pay-form');
                const submitButton = document.getElementById('submit-form');
                const mail = document.getElementById('reg-mail') as HTMLInputElement;
                const confirmemail = document.getElementById('confirm-reg-mail') as HTMLInputElement;

                if (this.value == 'swedbank') {
                    //@ts-ignore
                    $(mail)?.rules('add', {
                        required: true
                    });

                    //@ts-ignore
                    $(confirmemail)?.rules('add', {
                        required: true
                    });

                    payButton.classList.remove('hidden');
                    if (!submitButton.classList.contains('hidden')) {
                        submitButton.classList.add('hidden');
                    }
                } else {
                    //@ts-ignore
                    $(mail)?.rules('add', {
                        required: false
                    });

                    //@ts-ignore
                    $(confirmemail)?.rules('add', {
                        required: false
                    });
                    submitButton.classList.remove('hidden');
                    if (!payButton.classList.contains('hidden')) {
                        payButton.classList.add('hidden');
                    }
                }
            });
        });
    } else {
        document.getElementById('submit-form')?.classList.remove('hidden');
    }

    // @ts-ignore
    $('#registerSupportMember').validate({
        onkeyup: false,
        errorClass: 'invalid',
        validClass: 'success',
        focusInvalid: false,
        rules: {
            socialsecurity: {
                required: true,
                minlength: 12,
                maxlength: 12,
                personnummer: true,
                number: true,
                remote: 'PersonExists',
            },
            firstname: {
                required: true,
                minlength: 2,
            },
            lastname: {
                required: true,
                minlength: 2,
            },
            address: {
                required: true,
                minlength: 2,
            },
            zipcode: {
                required: true,
                nas: true,
                postnummer: true,
                zipcode: true,
                maxlength: 6,
            },
            city: {
                required: true,
                minlength: 2,
            },
            phonenumber: {
                required: false,
                nhas: true,
            },
            mobilephone: {
                required: false,
                nhas: true,
                saMobil: true,
            },
            email: {
                required: false,
                customemail: true,
            },
            confirmemail: {
                required: false,
                customemail: true,
                equalTo: '#reg-mail',
            },
        },
        messages: {
            phonenumber: {
                nhas: 'Ange telefonnummer inklusive riktnummer',
            },
            mobilephone: {
                nhas: 'Ange mobiltelefonnummer',
                saMobil: 'Ange ett giltigt svenskt eller utländskt telefonnummer',
            },
            firstname: {
                required: 'Ange förnamn',
            },
            lastname: {
                required: 'Ange efternamn',
            },
            address: {
                required: 'Ange adress',
            },
            zipcode: {
                required: 'Ange postnummer',
            },
            city: {
                required: 'Ange ort',
            },
            socialsecurity: {
                remote: 'Tekniskt fel eller så finns personnumret du angav redan registrerat. Vänligen kontakta info@spfseniorerna.se',
            },
            mail: {
                required: 'Ange epostadress',
            },
            confirmemail: {
                required: 'Bekräfta E-post'
            }
        },

        invalidHandler: function (form, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
                // @ts-ignore
                var firstErrorElement = $(validator.errorList[0].element);
                // @ts-ignore
                $('html, body').animate({
                    scrollTop: firstErrorElement.offset().top - 40,
                });

                firstErrorElement.focus();
            }
        },
        success: function (label) {
            label.addClass('success');
        },
        submitHandler: function (form, e) {
            e.preventDefault();
            const method = document.querySelector('input[name="paymentMethod"]:checked') as HTMLInputElement;
            if (method?.value == 'swedbank') {
                // If the Pay button is already clicked, do nothing
                if (form.hasAttribute('data-submitting')) {
                    return;
                }
                form.setAttribute('data-submitting', '');
                const submitbuttons = form.querySelectorAll('input[type="submit"]');
                submitbuttons.forEach((btn) => {
                    btn.classList.add('hidden');
                });
                disableElements(submitbuttons);

                document.getElementById('submition-update').innerHTML = 'En betalning har redan påbörjats.';

                const socialSecurityNumber = document.getElementById('social-security-num-sup') as HTMLInputElement;
                const firstName = document.getElementById('reg-first-name') as HTMLInputElement;
                const lastName = document.getElementById('reg-surname') as HTMLInputElement;
                const address = document.getElementById('reg-address') as HTMLInputElement;
                const zipCode = document.getElementById('reg-zip') as HTMLInputElement;
                const city = document.getElementById('reg-city') as HTMLInputElement;
                const coAddress = document.getElementById('reg-co') as HTMLInputElement;
                const mail = document.getElementById('reg-mail') as HTMLInputElement;
                const phone = document.getElementById('reg-phone') as HTMLInputElement;
                const mobilePhone = document.getElementById('reg-mobilephone') as HTMLInputElement;
                const recommendedUnion = document.querySelector('input[name=rbSupportMember]:checked') as HTMLInputElement;
                const paymentMethod = document.querySelector('input[name=paymentMethod]:checked') as HTMLInputElement;

                disableElements([
                    socialSecurityNumber,
                    firstName,
                    lastName,
                    address,
                    zipCode,
                    city,
                    coAddress,
                    mail,
                    phone,
                    mobilePhone,
                    ...document.querySelectorAll('input[name=paymentMethod]'),
                    document.getElementById('selectDistrict'),
                    document.getElementById('confirm-reg-mail'),
                ]);

                let unionId = recommendedUnion.value;

                const userDetails = {
                    SocialSecurityNumber: socialSecurityNumber.value,
                    FirstName: firstName.value,
                    LastName: lastName.value,
                    Address: address.value,
                    ZipCode: zipCode.value,
                    City: city.value,
                    CoAddress: coAddress.value,
                    Mail: mail.value,
                    Phone: phone.value,
                    MobilePhone: mobilePhone.value,
                    UnionId: 0,
                    PaymentMethod: paymentMethod.value,
                    SupportUnion: true,
                };

                sessionStorage.setItem(sessionStoregeItemAndCookieName, JSON.stringify(userDetails));

                const requestVerificationToken = document.querySelector('input[name=__RequestVerificationToken]') as HTMLInputElement;
                // @ts-ignore
                $.ajax({
                    url: '/api/payment/InitiatePayment/',
                    data: JSON.stringify(userDetails),
                    contentType: 'application/json',
                    type: 'POST',
                    headers: {
                        RequestVerificationToken: requestVerificationToken?.value,
                    },
                    success: function (data) {
                        if (data.status == 200) {
                            var script = document.createElement('script');
                            script.setAttribute('src', data.url);

                            script.onload = function () {
                                // When the 'view-checkout' script is loaded, we can initialize the
                                // Payment Menu inside 'checkout-container'.
                                // @ts-ignore
                                payex.hostedView
                                    .paymentMenu({
                                        container: 'checkout-container',
                                        culture: 'sv-SE',
                                        onPaid: onPaymentCompletedHandler,
                                        onPaymentAttemptStarted: onPaymentAttemptStarted
                                    })
                                    .open();
                            };
                            var head = document.getElementsByTagName('head')[0];
                            head.appendChild(script);

                            document.getElementById('submition-update').innerHTML = 'Betalningsalternativen är tillgängliga.';

                            if (cancelButton) {
                                const data = Cookies.get(sessionStoregeItemAndCookieName);
                                const cookieData = JSON.parse(data) as CookieData;
                                cancelButton.addEventListener('click', function () {
                                    onCancelClick(cookieData.paymentRef);
                                });
                                cancelButton.classList.remove('hidden');
                            }
                        } else {
                            window.location = data.url;
                        }
                    },
                    error: function (ex) {
                        console.error(ex);
                    },
                });
            } else {
                 // If the form is already submitting, do nothing
            if (form.hasAttribute('data-submitting')) 
                {
                    return;
                }
                form.setAttribute('data-submitting', '');
    
                const submitbuttons = form.querySelectorAll('input[type="submit"]');
                submitbuttons.forEach((btn) => {
                    btn.setAttribute('disabled', '');
                });
                document.getElementById('submition-update').innerHTML = "Formuläret har skickats och bearbetar informationen";
                form.submit();
            }
        }
  });
});

const onPersonalNumberChange = function (e : Event) {
    let input = e.target as HTMLInputElement;
    if (input.value.length == 13 || input.value.length == 12) {
        let year = parseInt(input.value.substring(0,4), 10);
        let month = parseInt(input.value.substring(4,6), 10);
        let day = parseInt(input.value.substring(6,8), 10);

        if (isNaN(year) || isNaN(month) || isNaN(day)){
            return;
        }

        const registrationMarker = document.getElementById('supportregistrationpage');
        const parsed = parseInt(registrationMarker?.dataset.cutoff);
        const cutoffYear = isNaN(parsed) ? 64 : parsed; //fallback to current value

        year = year + cutoffYear;
        month = month - 1;

        var birthDate = new Date(year, month, day);
        var now = new Date();
        var overRadio = document.querySelector('#reg-support-member-over') as HTMLInputElement;
        var underRadio = document.querySelector('#reg-support-member-under') as HTMLInputElement;
        if (birthDate < now) {
            overRadio.checked = true;
            underRadio.checked = false;
        } else {
            overRadio.checked = false;
            underRadio.checked = true;
        }
    }
};
